import { useFormContext } from "react-hook-form";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { tableService } from "../../../../../../app/services/tableService";
import { CreateTableParams } from "../../../../../../app/services/tableService/createTable";
import { useToast } from "../../../../../components/ui/use-toast";
import { FormCreateTableData } from "../../../PartnersPage/usePartnersPageController";

export const useAddTableCardController = () => {
  const methods = useFormContext<FormCreateTableData>();
  const queryClient = useQueryClient();

  const { toast } = useToast();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ["createTable"],
    mutationFn: async (data: CreateTableParams) =>
      await tableService.createTable(data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["allTables"],
      });
    },
  });

  const handleAddTable = async (data: FormCreateTableData) => {
    try {
      const formattedData = {
        ...data,
        percents: data.percents ? Number(data.percents) : 0,
        maxPercents: data.maxPercents ? Number(data.maxPercents) : 0,
        bonus: data.bonus ? Number(data.bonus) : 0,
        leaderCommission: data.leaderCommission ? Number(data.leaderCommission) : 0,
        limit: data.limit ? Number(data.limit.replace(/\D/g, "")) : 0,
      };

      const response = await mutateAsync(formattedData);

      if (response.name === data.name) {
        toast({
          title: "Tabela criada com sucesso!",
        });

        methods.reset();
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error);
      toast({
        variant: "destructive",
        title:
          error?.message ||
          "Ocorreu um erro ao tentar criar a tabela, tente novamente mais tarde.",
      });
    }
  };

  return {
    methods,
    isPending,
    handleAddTable,
  };
};
